import { AppColors } from "@/styles/colors";
import { GridItem, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface Props {
    label: string
    children: ReactNode
    striped?: boolean
}

export const StripeRow = ({
    label,
    children,
    striped,
}: Props) => {
    const bg = striped ? AppColors.BACKGROUND_SECONDARY : undefined;
    return (
        <>
            <GridItem
                paddingX="24px"
                paddingY="8px"
                backgroundColor={bg}
                display="flex"
                alignItems="center"
                minH="50px"
            >
                <Text className="account-title-label">{label}:</Text>
            </GridItem>
            <GridItem
                paddingX="24px"
                paddingY="8px"
                backgroundColor={bg}
                display="flex"
                alignItems="center"
                minH="50px"
            >
                {children}
            </GridItem>
        </>
    );
};